window.jQuery = $;
window.$ = $;

import './scripts/main';
import { setupForm } from './scripts/forms';
import { checkSticky } from './scripts/sticky';
import { setupCardDeckSwiperForSmallerMobile, setupCardDeckSwiperForDesktop } from './scripts/swipers';
require("@rails/ujs").start()

$('#search-button').on('click', () => {
  $('#search-wrapper').addClass('active');
});

$('#search-clear').on('click', () => {
  $('#search-wrapper').removeClass('active');
  $('#search-wrapper input').val('');
});

document.addEventListener('addposts', () => { checkSticky(); });

$(".blog_stick_container").height($('#blog-sticky-parent').height() - $('#blog-sticky-start').height())

const $blogForm = $('#blog-promo-form');
setupForm($blogForm, $blogForm.siblings('.thank-you-overlay'));

const $debouncedElement = $({});

const adaptElements = () => {
  setupCardDeckSwiperForDesktop('#featured_block');
  setupCardDeckSwiperForDesktop('#company_block');
  setupCardDeckSwiperForSmallerMobile('#author_block');
}

$(window).on("resize", () => {
  $debouncedElement.stop(true, true).delay(40).queue(() => {
    adaptElements();
    $debouncedElement.dequeue();
  });
});

adaptElements()

